export default "__VITE_ASSET__C5lTxhuf__"